import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-job-reports',
  templateUrl: './job-reports.component.html',
  styleUrls: ['./job-reports.component.scss']
})
export class JobReportsComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
